export default "__VITE_ASSET__DGQ2NYII__"